import { BlogListReducer } from "../reducer/BlogListReducer";

export const reducer = BlogListReducer;
